import React from "react";
import PropTypes from "prop-types";
// Material imports
import withStyles from "@mui/styles/withStyles";
// Limitless imports
import AttachmentBody from "../../attachment-body/AttachmentBody";
import CustomerDialogueWrapper from "./CustomerDialogueWrapper";
import DialogueBody from "../../dialogue-body/DialogueBody";
const CustomerAttachmentDialogue = ({
  classes,
  dialogue,
  shouldAnimate
}) => {
  const isRtl = document.documentElement.getAttribute("dir") === "rtl";
  const {
    body,
    attachments
  } = dialogue;
  return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(CustomerDialogueWrapper, {
    dialogue: dialogue,
    shouldAnimate: shouldAnimate,
    isCustomerAttachment: true
  }, customerClasses => /*#__PURE__*/React.createElement("div", {
    className: classes.dialogueContainer
  }, attachments && attachments.map((attachment, index) => /*#__PURE__*/React.createElement("div", {
    key: index,
    className: `${classes.attachmentDialogueContainer} ${isRtl ? classes.rtlAlignment : classes.ltrAlignment}`
  }, /*#__PURE__*/React.createElement(AttachmentBody, {
    backgroundStyle: customerClasses.customerBackground,
    textStyling: customerClasses.customerText,
    attachment: attachment,
    isCustomer: true
  }), body && /*#__PURE__*/React.createElement("div", {
    className: classes.attachmentBody
  }, /*#__PURE__*/React.createElement(DialogueBody, {
    body: body,
    textStyling: customerClasses.customerText
  })))))));
};
const styles = ({
  palette
}) => ({
  dialogueContainer: {
    display: "flex",
    flexDirection: "column",
    alignItems: "flex-end",
    margin: 0,
    padding: 0
  },
  attachmentDialogueContainer: {
    maxWidth: "67%",
    alignItems: "center",
    borderRadius: 12,
    display: "flex",
    flexDirection: "row"
  },
  ltrAlignment: {
    marginLeft: "auto",
    marginRight: 5,
    flexDirection: "row"
  },
  rtlAlignment: {
    marginRight: "auto",
    marginLeft: 5,
    flexDirection: "row-reverse"
  },
  attachmentBody: {
    marginLeft: 8
  }
});
CustomerAttachmentDialogue.propTypes = {
  classes: PropTypes.object,
  dialogue: PropTypes.object.isRequired,
  shouldAnimate: PropTypes.bool.isRequired
};
export default withStyles(styles)(CustomerAttachmentDialogue);